// extracted by mini-css-extract-plugin
export default {"sepaExpressContainer":"e3uOq2pmcMyuyJbGRGLg","placeOrderButton":"FztxxwdpvDdl1R9kuOVf"};